import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
};

export default function operacaobatelada(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@operacaobatelada/FIND_OPERACAOBATELADA':
      case '@operacaobatelada/UPDATE_OPERACAOBATELADA':
      case '@operacaobatelada/DELETE_OPERACAOBATELADA':
      case '@operacaobatelada/STORE_OPERACAOBATELADA':
      case '@operacaobatelada/OPERACAOBATELADAS_IN_REQUEST':
      case '@operacaobatelada/UPDATE': {
        draft.loading = true;
        break;
      }

      case '@operacaobatelada/SUCCESS_REMOVE':
      case '@operacaobatelada/FAILED_REQUEST': {
        draft.loading = false;
        break;
      }

      case '@operacaobatelada/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.operacaobateladas;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@operacaobatelada/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.operacaobatelada;
        break;
      }

      case '@operacaobatelada/RECORD_FILTERING': {
        draft.loading = true;
        draft.params = { ...draft.params, ...action.payload.params };
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}
